import { CounterOrderDirection } from "@/app/types/generated/graphql";

import { CounteredOrdersView, useCounteredOrders } from "../components/countered-orders";

export const ReceivedCounterOffers = () => {
  const logic = useCounteredOrders(CounterOrderDirection.Incoming);

  return <CounteredOrdersView {...logic} />;
};
